module.exports = __webpack_public_path__ + "img/calculator_01.33b6d363.png";